export default [
    {
        title: "Understanding Cyber Security and the Dangers of Spear Phishing",
        content: "Why Spear Phishing is different",
        videoSrc: "https://projectspectrumlearning.io/ivs/Understanding%20Cyber%20Security%20and%20the%20Dangers%20of%20Spear.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Understanding%20Cyber%20Security%20and%20the%20Dangers%20of%20Spear.jpg",
        videoNum: "1.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "The Importance of Cybersecurity Awareness",
        content: "Be aware of all the issues",
        videoSrc: "https://projectspectrumlearning.io/ivs/The%20Importance%20of%20Cybersecurity%20Awareness.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/The%20Importance%20of%20Cybersecurity%20Awareness.jpg",
        videoNum: "2.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Exploring Application Cybersecurity Coding Standards",
        content: "Make sure your code is safe",
        videoSrc: "https://projectspectrumlearning.io/ivs/Exploring%20Application%20Cybersecurity%20Coding%20Standards.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Exploring%20Application%20Cybersecurity%20Coding%20Standards.jpg",
        videoNum: "3.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Insider Threat Management",
        content: "Insiders are often ignored",
        videoSrc: "https://projectspectrumlearning.io/ivs/Insider%20Threat%20Management.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Insider%20Threat%20Management.jpg",
        videoNum: "4.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cyber Kill Chain Explained",
        content: "Understanding the threats",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cyber%20Kill%20Chain%20Explained.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Cyber%20Kill%20Chain%20Explained.jpg",
        videoNum: "5.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Business Continuity Plan",
        content: "Important and overlooked!",
        videoSrc: "https://projectspectrumlearning.io/ivs/Business%20Continuity%20Plan_Final.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Business%20Continuity%20Plan_Final.jpg",
        videoNum: "6.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Zero Trust Architecture",
        content: "What exactly is zero trust?",
        videoSrc: "https://projectspectrumlearning.io/ivs/Zero-Trust%20Architecture.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Zero-Trust%20Arcitecture.jpg",
        videoNum: "7.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cybersecurity Acronyms: A Comprehensive Guide",
        content: "Reducing the confusion",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cybersecurity%20Acronyms_A%20Comprehensive%20Guide.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Cybersecurity%20Acronyms_A%20Comprehensive%20Guide.jpg",
        videoNum: "8.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Phishing Unveiled Protecting Your Organization From Cyber Threats",
        content: "What and how to avoid",
        videoSrc: "https://projectspectrumlearning.io/ivs/Phishing%20Unveiled_%20Protecting%20Your%20Organization%20from%20Cyber%20Threats.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Phishing%20Unveiled_%20Protecting%20Your%20Organization%20from%20Cyber%20Threats.jpg",
        videoNum: "9.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Multi-Factor Authentication",
        content: "Be Sure It's You",
        videoSrc: "https://projectspectrumlearning.io/ivs/MFA.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/MFA.jpg",
        videoNum: "10.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Building a Comprehensive Online Cybersecurity Plan",
        content: "Planning to prevent!",
        videoSrc: "https://projectspectrumlearning.io/ivs/Building%20a%20Comprehensive%20Online%20Cybersecurity%20Plan.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Cybersecurity%20Plan.jpg",
        videoNum: "11.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Securing Remote Work: Building Your Cybersecurity Plan",
        content: "Easier than you think",
        videoSrc: "https://projectspectrumlearning.io/ivs/Securing%20Remote%20Work_%20Building%20Your%20Cybersecurity%20Plan.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Securing%20Remote%20Work.jpg",
        videoNum: "12.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cybersecurity Resilience and Disaster Recovery",
        content: "Survive & Thrive!",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cybersecurity%20Resilience%20and%20Disaster%20Recovery.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Cyber%20Security%20Resilience%20and%20Disaster%20Recovery.jpg",
        videoNum: "13.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Understanding and Detecting Cybersecurity Threats in the Internet",
        content: "Learn about the threats!",
        videoSrc: "https://projectspectrumlearning.io/ivs/Understanding%20and%20Detecting%20Cybersecurity%20Threats%20in%20the%20Internet.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Understanding%20and%20Detecting%20Cybersecurity%20Threats%20in%20the%20Internet%20of%20Things%20(IoT).jpg",
        videoNum: "14.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Employee Cyber Education",
        content: "Education is key",
        videoSrc: "https://projectspectrumlearning.io/ivs/Employee%20Cyber%20Education.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Employee%20Cyber%20Education.jpg",
        videoNum: "15.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Quishing 101: How to spot and avoid QR Code Phishing Scams",
        content: "Quishing is real",
        videoSrc: "https://projectspectrumlearning.io/ivs/Quishing%20101_%20How%20to%20Spot%20and%20Avoid%20QR.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Quishing%20101_%20How%20to%20Spot%20and%20Avoid%20QR%20Code%20Phishing%20Scams.jpg",
        videoNum: "16.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Ransomware Prevention",
        content: "Prevention vs Cure",
        videoSrc: "https://projectspectrumlearning.io/ivs/Ransomeware%20Prevention.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Ransomware%20Prevention.jpg",
        videoNum: "17.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Understanding and Preventing Spoofing Emails",
        content: "Spoofing is not kidding!",
        videoSrc: "https://projectspectrumlearning.io/ivs/Understanding%20and%20Preventing%20Spoofing%20Emails.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Understanding%20and%20Preventing%20Spoofing%20Emails.jpg",
        videoNum: "18.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cybersecurity and FOCI Impact",
        content: "Be aware that your partner may not be US based",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cybersecurity%20and%20FOCI%20Impact.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Cybersecurity%20and%20FOCI%20Impact.jpg",
        videoNum: "19.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cybersecurity Incident Response and Recovery",
        content: "Learn how now before it's needed",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cybersecurity%20Incident%20Response%20and%20Recovery.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Incident%20Response%20and%20Recovery%20Cover.jpg",
        videoNum: "20.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Mastering Configuration Management",
        content: "Review your configurations often",
        videoSrc: "https://projectspectrumlearning.io/ivs/'Mastering%20Configuration%20Management_%20Streamlining%20IT%20Environments%20with%20Effective.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Mastering%20Configuration%20Management.jpg",
        videoNum: "21.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Online Cyber Safety",
        content: "You and YOUR info are exposed",
        videoSrc: "https://projectspectrumlearning.io/ivs/Online%20Cyber%20Safety.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Online%20Cyber%20Safety.jpg",
        videoNum: "22.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Supply Chain Cybersecurity",
        content: "Importance of the supply chain",
        videoSrc: "https://projectspectrumlearning.io/ivs/Supply_Chain_Cybersecurity2.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/Supply_Chain_Cybersecurity2.jpg",
        videoNum: "23.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cloud Management",
        content: "The cloud needs protection too",
        videoSrc: "https://projectspectrumlearning.io/ivs/Cloud%20Management.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/cloud%20management.jpg",
        videoNum: "24.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "The Pareto Principle and Cybersecurity",
        content: "20% of effort = 80% of Cyber Results",
        videoSrc: "https://projectspectrumlearning.io/ivs/The%20Pareto%20Principle%20and%20Cybersecurity.mp4",
        thumbnail: "https://projectspectrumlearning.io/ivs/ivthumbs/The%20Pareto%20Principle%20and%20Cybersecurity.jpg",
        videoNum: "25.0",
        videoType: "Informational Video",
        isMP4Player: "true",
    },
    {
        title: "Cyber Awareness",
        content: "Gain knowledge of common threats and attack vectors",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/96e7d4dac4d6001078b6ce8ed5912bc2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F96e7d4dac4d6001078b6ce8ed5912bc2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D10s%26height%3D600",
        videoNum: "1.1",
        videoType: "Cybersecurity",
    },
    {
        title: "Study Best Practices",
        content: "Learn about fundamental cybersecurity practices such as data encryption, software updates, and password management",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/8526408ff71d724f663088320db8d080/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F8526408ff71d724f663088320db8d080%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D58s%26height%3D600",
        videoNum: "1.2",
        videoType: "Cybersecurity",
    },
    {
        title: "Strategies of Readiness",
        content: "Gain knowledge on the importance of learning cyber frameworks and standards",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/eac719cd2d4e8f95271eca8d732a3867/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Feac719cd2d4e8f95271eca8d732a3867%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D40s%26height%3D600",
        videoNum: "1.3",
        videoType: "Cybersecurity",
    },
    {
        title: "Kill Chain",
        content: "Learn about the framework developed by Lockheed Martin to help understand and counteract cyber threats",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/84c1d8a1face5b2988026e81d93d78cc/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F84c1d8a1face5b2988026e81d93d78cc%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m52s%26height%3D600",
        videoNum: "1.4",
        videoType: "Cybersecurity",
    },
    // {
    //     title: "Our Core Objectives",
    //     content: "Obtain an overview of the core objectives and scope of Project Spectrum",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4a14350bed121fb184eb4dd0e7c86ef5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4a14350bed121fb184eb4dd0e7c86ef5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D14s%26height%3D600",
    //     videoNum: "2.1",
    //     videoType: "Project Spectrum",
    // },
    // {
    //     title: "View Case Studies",
    //     content: "Examine case studies and success stories pertaining to the utilization of Project Spectrum",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9455f5cfa31e0f90d18eb46656684c2e/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9455f5cfa31e0f90d18eb46656684c2e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D18s%26height%3D600",
    //     videoNum: "2.2",
    //     videoType: "Project Spectrum",
    // },
    // {
    //     title: "Resource Overview",
    //     content: "Project Spectrum many resources at your side",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d9cd68e19e5af740e90b792bb1d9390b/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd9cd68e19e5af740e90b792bb1d9390b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m25s%26height%3D600",
    //     videoNum: "2.3",
    //     videoType: "Project Spectrum",
    // },
    {
        title: "Industry Forecasting",
        content: "Keep abreast of current technological advancements in the field",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/aed38f245dea01905618525faeff0830/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faed38f245dea01905618525faeff0830%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m9s%26height%3D600",
        videoNum: "3.1",
        videoType: "Spectrum Manufacturers",
    },
    {
        title: "Prioritize Optimization",
        content: "Examine automation as a means of streamlining current procedures and systems",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/b6a7b4691f7260e357f440eb12021349/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fb6a7b4691f7260e357f440eb12021349%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m8s%26height%3D600",
        videoNum: "3.2",
        videoType: "Spectrum Manufacturers",
    },
    {
        title: "Manufacturing Vulnerabilities",
        content: "Protect your operations and facilities",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/a21777f32a5b9bd686a7287f61131705/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fa21777f32a5b9bd686a7287f61131705%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D50s%26height%3D600",
        videoNum: "3.3",
        videoType: "Spectrum Manufacturers",
    },
    {
        title: "Identify Data Types",
        content: "Define the types of data the business will collect, process, and store",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/23fe2247dc7b8356f1ca09e6bc712c38/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F23fe2247dc7b8356f1ca09e6bc712c38%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D56s%26height%3D600",
        videoNum: "4.1",
        videoType: "Understanding Data",
    },
    {
        title: "Decision Making",
        content: "Consider data analysis and visualization techniques to draw conclusions from your data",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/65ce5269ae9a23bc961f8c0e104e0531/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F65ce5269ae9a23bc961f8c0e104e0531%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m41s%26height%3D600",
        videoNum: "4.2",
        videoType: "Understanding Data",
    },
    {
        title: "Implementation",
        content: "Implement governance procedure for quality, security, and compliance",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9d60180bb746b051385e9bf7a4d219a2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9d60180bb746b051385e9bf7a4d219a2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m03s%26height%3D600",
        videoNum: "4.3",
        videoType: "Understanding Data",
    },
    {
        title: "Essential Requirements",
        content: "Determine your company's unique requirements and objectives",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d4376d5a04169d5b9ae4ed14046824e6/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd4376d5a04169d5b9ae4ed14046824e6%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D51s%26height%3D600",
        videoNum: "5.1",
        videoType: "Business Tools",
    },
    {
        title: "Equip Yourself",
        content: "Research and evaluate tools specific to your industry and business size",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/2a01eb3a5e8c20225e3e9253658c81c5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F2a01eb3a5e8c20225e3e9253658c81c5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m13s%26height%3D600",
        videoNum: "5.2",
        videoType: "Business Tools",
    },
    {
        title: "Final Determination",
        content: "Selecting your final option, consider integration and cost scalability",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/832df5241c3a54e4635d48037a894212/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F832df5241c3a54e4635d48037a894212%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m24s%26height%3D600",
        videoNum: "5.3",
        videoType: "Business Tools",
    },
    // {
    //     title: "What is CMMC?",
    //     content: "Learn about the CMMC program of the Department of Defense (DoD)",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/ca129ca1db7d642672672e7fab2b8cc4/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fca129ca1db7d642672672e7fab2b8cc4%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m26s%26height%3D600",
    //     videoNum: "6.1",
    //     videoType: "CMMC",
    // },
    // {
    //     title: "What is Level 1?",
    //     content: "Learn about the foundational tier of CMMC",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4bcb68d73d3d3f42236370a426264857/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4bcb68d73d3d3f42236370a426264857%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m20s%26height%3D600",
    //     videoNum: "6.2",
    //     videoType: "CMMC",
    // },
    // {
    //     title: "What is Level 2?",
    //     content: "Learn about the advanced tier of CMMC",
    //     videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/91da3ee47ac59d2f4d3cbc2c30a7832f/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F91da3ee47ac59d2f4d3cbc2c30a7832f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m06s%26height%3D600",
    //     videoNum: "6.3",
    //     videoType: "CMMC",
    // },
    {
        title: "What is NIST 800-171?",
        content: "Learn about a set of security framework requirements issued by DoD",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/af44010cc39f19ddc44e7976d37cb095/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faf44010cc39f19ddc44e7976d37cb095%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D22s%26height%3D600",
        videoNum: "7.1",
        videoType: "NIST 800-171",
    },
    {
        title: "NIST 800-171 vs CMMC Level 1",
        content: "What are the differences between these two?",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/05509b84b6db3c0ebadf3cd2e72d6ba0/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F05509b84b6db3c0ebadf3cd2e72d6ba0%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D57s%26height%3D600",
        videoNum: "7.2",
        videoType: "NIST 800-171",
    },
    {
        title: "NIST 800-171 vs CMMC Level 2",
        content: "What are the differences between these two?",
        videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/7c87af2802c6f1b3332670345477a295/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F7c87af2802c6f1b3332670345477a295%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D41s%26height%3D600",
        videoNum: "7.3",
        videoType: "NIST 800-171",
    },
];